function firstNonEmptyString() {
    var cands = [];
    for (var _i = 0; _i < arguments.length; _i++) {
        cands[_i] = arguments[_i];
    }
    for (var i = 0; i < cands.length; i++) {
        var value = cands[i];
        if (typeof value === 'string' && value.trim().length) {
            return value.trim();
        }
    }
    return undefined;
}
function rowFromImageObject(img) {
    if (!img || typeof img !== 'object') {
        return null;
    }
    var o = img;
    var url = firstNonEmptyString(o.imageurl, o.ImageUrl, o.niceUrl, o.NiceUrl, o.url, o.Url);
    return url ? { imageurl: url } : null;
}
function variantKey(style, color) {
    return String(style) + '_' + String(color);
}
function sortOrderFromImage(img) {
    var value = img.sort_order !== undefined ? img.sort_order : img.SortOrder;
    if (typeof value === 'number' && !isNaN(value)) {
        return value;
    }
    if (typeof value === 'string') {
        var parsed = parseInt(value, 10);
        return isNaN(parsed) ? 0 : parsed;
    }
    return 0;
}
function normalizeLegacyLikeMap(obj) {
    var out = {};
    var keys = Object.keys(obj);
    for (var i = 0; i < keys.length; i++) {
        var key = keys[i];
        var value = obj[key];
        if (!Array.isArray(value)) {
            continue;
        }
        var rows = [];
        for (var j = 0; j < value.length; j++) {
            var row = rowFromImageObject(value[j]);
            if (row) {
                rows.push(row);
            }
        }
        if (rows.length) {
            out[key] = rows;
        }
    }
    return out;
}
function normalizeAssetManagerEntriesIndex(obj) {
    var entries = obj.entries !== undefined ? obj.entries : obj.Entries;
    if (!Array.isArray(entries) || entries.length === 0) {
        return null;
    }
    var out = {};
    for (var i = 0; i < entries.length; i++) {
        var entry = entries[i];
        if (!entry || typeof entry !== 'object') {
            continue;
        }
        var ent = entry;
        var style = firstNonEmptyString(ent.style_code, ent.StyleCode, ent.style, ent.Style, ent.masterId, ent.MasterId);
        var color = firstNonEmptyString(ent.color_code, ent.ColorCode, ent.color, ent.Color, ent.colorCode);
        var season = firstNonEmptyString(ent.season, ent.Season);
        if (!style || !color || !season) {
            continue;
        }
        var images = ent.images !== undefined ? ent.images : ent.Images !== undefined ? ent.Images : undefined;
        if ((!Array.isArray(images) || images.length === 0) && ent.primary_image) {
            images = [ent.primary_image];
        }
        if (!Array.isArray(images) || images.length === 0) {
            continue;
        }
        var sorted = images.slice().sort(function (a, b) {
            if (!a || typeof a !== 'object')
                return 1;
            if (!b || typeof b !== 'object')
                return -1;
            return sortOrderFromImage(a) - sortOrderFromImage(b);
        });
        var rows = [];
        for (var j = 0; j < sorted.length; j++) {
            var img = sorted[j];
            if (!img || typeof img !== 'object') {
                continue;
            }
            var image = img;
            var filename = firstNonEmptyString(image.filename, image.Filename);
            var s3Key = firstNonEmptyString(image.s3_key, image.S3Key, image.s3Key);
            var directUrl = rowFromImageObject(img);
            if (s3Key) {
                rows.push({ imageurl: '/' + s3Key.replace(/^\/+/, '') });
            }
            else if (filename) {
                rows.push({ imageurl: '/' + season + '/' + filename.replace(/^\/+/, '') });
            }
            else if (directUrl) {
                rows.push(directUrl);
            }
        }
        if (rows.length) {
            out[variantKey(style, color)] = rows;
        }
    }
    return Object.keys(out).length ? out : null;
}
function flattenVariantsArray(arr) {
    var out = {};
    for (var i = 0; i < arr.length; i++) {
        var item = arr[i];
        if (!item || typeof item !== 'object') {
            continue;
        }
        var obj = item;
        var style = firstNonEmptyString(obj.style_code, obj.StyleCode, obj.style, obj.Style, obj.masterId, obj.MasterId);
        var color = firstNonEmptyString(obj.color_code, obj.ColorCode, obj.color, obj.Color, obj.colorCode);
        var images = obj.images !== undefined ? obj.images : obj.Images;
        if (!style || !color || !Array.isArray(images)) {
            continue;
        }
        var rows = [];
        for (var j = 0; j < images.length; j++) {
            var row = rowFromImageObject(images[j]);
            if (row) {
                rows.push(row);
            }
        }
        if (rows.length) {
            out[variantKey(style, color)] = rows;
        }
    }
    return out;
}
function unwrapRoot(raw) {
    if (!raw || typeof raw !== 'object' || Array.isArray(raw)) {
        return raw;
    }
    var root = raw;
    return root.data !== undefined
        ? root.data
        : root.Data !== undefined
            ? root.Data
            : root.index !== undefined
                ? root.index
                : root.Index !== undefined
                    ? root.Index
                    : raw;
}
export function normalizePacksIndexToImageMap(raw) {
    if (raw == null) {
        return {};
    }
    var root = unwrapRoot(raw);
    if (typeof root === 'string') {
        try {
            root = unwrapRoot(JSON.parse(root));
        }
        catch (_e) {
            return {};
        }
    }
    if (Array.isArray(root)) {
        return flattenVariantsArray(root);
    }
    if (typeof root === 'object' && root !== null) {
        var obj = root;
        var fromEntries = normalizeAssetManagerEntriesIndex(obj);
        if (fromEntries) {
            return fromEntries;
        }
        if (Array.isArray(obj.variants)) {
            return flattenVariantsArray(obj.variants);
        }
        if (Array.isArray(obj.items)) {
            return flattenVariantsArray(obj.items);
        }
        if (Array.isArray(obj.Items)) {
            return flattenVariantsArray(obj.Items);
        }
        var flattened = flattenVariantsArray([obj]);
        return Object.keys(flattened).length ? flattened : normalizeLegacyLikeMap(obj);
    }
    return {};
}
//# sourceMappingURL=packsIndexNormalize.js.map